import { AdditionalContentAccordionGroup } from '@components/common/additional-content-accordion-group/additional-content-accordion-group';

const LayoutTesto = ({ translations = {}, darkTheme = false, id = '' }) => {
  return (
    <div
      className="snf-lx-components-servizi-soluzioni-layout-testo-layout-testo"
      style={{ display: 'contents' }}
    >
      <>
        <div className="row">
          <div className="col-12 snf-font-16 paragraph p-0">
            <div
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{ __html: translations.paragraph }}
            />
          </div>
        </div>
        <AdditionalContentAccordionGroup
          translations={translations}
          darkTheme={darkTheme}
          id={id}
        />
      </>
    </div>
  );
};

LayoutTesto.displayName = 'Layout Testo ';
export { LayoutTesto };
